<template>
    <div id="data-list-thumb-view" class="data-list-container">

      <vs-popup title="Rapor Seçimi" :active.sync="isPopupActive" class="text-center">
  <p class="mb-6">Rapor Türünü Seçiniz</p>
  <div class="flex justify-center gap-4">
    <vs-button color="primary" type="filled" @click="getExcelReport()">Excel</vs-button>
    <vs-button color="primary" type="filled" @click="getLocalReport()">Anlık</vs-button>
  </div>
</vs-popup>


      <div
          slot="header"
          class="w-full flex flex-wrap items-center flex-grow justify-between" style="margin-bottom: 1rem;"
        >
        <global-filter
              ref="filterer"
              :tableOptions="tableOptions"
              :filterOptions="filterOptions"
              :filterChips="filterChips"
              :filterOptionNames="filterOptionNames"
              :isActive="isFilterActive"
              @saveOptions="saveOptions"
              @close="isFilterActive = false"
            />
            <vs-row
              id="panelHeaderRow"
              v-show="!isFilterActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
              <vs-col
                id="panel-actions"
                vs-type="flex"
                class="w-auto"
                vs-justify="center"
              >
                <vs-row vs-type="flex" vs-w="12">
                  <vs-col vs-type="flex" vs-w="3.75">
                    <vx-tooltip text="Detaylı Filtereleme" position="top">
                      <vs-button
                        @click="isFilterActive = !isFilterActive"
                        class="panel-action text-warning xlarge-button panel-action-box-shadow"
                        color="transparent"
                        icon-pack="pickicon"
                        icon="icon-pick-filter"
                      >
                      </vs-button>
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col id="filter-chips" vs-type="flex">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-button
                    id="clearFilterButton"
                    v-if="filterChips.length > 0"
                    @click="clearFilter"
                    class="mr-2 bg-white text-danger panel-action-box-shadow"
                    icon-pack="feather"
                    icon="icon-slash"
                    radius
                    color="transparent"
                  />
                  <vs-col
                    vs-type="flex"
                    class="w-auto"
                    v-for="(chip, index) in filterChips"
                    :key="index"
                  >
                    <vs-chip
                      color="white"
                      class="panel-action-box-shadow px-1"
                      @click="removeFilter(chip.col, index)"
                      v-show="chip.value != ''"
                      closable
                    >
                      <vs-row vs-tpye="flex" vs-w="12">
                        <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                          <span class="bold text-xsmaller text-dark">
                            {{ chip.name + " :" }}
                          </span>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          class="w-auto ml-1"
                          vs-align="center"
                        >
                          <feather-icon
                            v-if="chip.value === true"
                            icon="CheckIcon"
                            svgClasses="w-4 h-4 text-primary"
                          />
                          <feather-icon
                            v-else-if="chip.value === false"
                            icon="XIcon"
                          />
                          <span
                            v-else
                            class="weight-600 italic text-xsmaller text-primary"
                          >
                            {{ chip.value }}
                          </span>
                        </vs-col>
                      </vs-row>
                    </vs-chip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col
                id="table-page-size"
                vs-type="flex"
                class="w-auto"
                vs-justify="flex-end"
              >
              </vs-col>
            </vs-row>
            <vs-row
              id="panelHeaderRow"
              v-show="tableActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
            <vs-col vs-type="flex" vs-w="6" style="margin-top: 1rem;">
                <vs-input icon-pack="feather" icon="icon-search" v-model="branchNameFilter"
                          placeholder="Şube İsmi Ara"
                          class="bg-white text-dark weight-600 w-full text-small" size="small"/>
              </vs-col>
          </vs-row>
            
      </div>
      <table v-if="tableActive" id="myTable">
  <thead id="tableHeader">
    <tr>
      <th style="width: 150px; position: sticky; top: 50px;">Şube Kodu</th>
      <th class="branch-name">Şube</th>
      <th style="width: 150px">Toplam</th>
      <template v-for="date in dates">
    <th style="width: 150px">{{ date }}</th>
  </template>
      <!-- Add more column headers if needed -->
    </tr>
  </thead>
  <tbody>
    <tr v-for="branch in uniqueBranches.filter(x=> branchNameFilter === '' || (branchNameFilter != '' && x.branchName.toLocaleLowerCase('tr-TR').includes(branchNameFilter.toLocaleLowerCase('tr-TR'))))" :key="branch">
      <td style="width: 150px">{{ branch.branchCode }}</td>
      <td class="branch-name">{{ branch.branchName }}</td>
      <!-- Diğer sütunlar -->
      <td style="width: 150px">{{ getTotalAmount(branch.branchName) }}</td>
      <td style="width: 150px" v-for="date in dates" :key="date">
      {{ getAmountForDate(branch.branchName, date) }}
    </td>
    </tr>
      
  </tbody>
</table>
    </div>
    
</template>

<script>
import GlobalFilter from "../../GlobalFilter";
import {getExcel, getAll} from "@/api/BranchWalletTransaction";
export default {
data(){
    return{
        isFilterActive: false,
        filterOptions: [
          "dateRange"
        ],
        filterOptionNames: [
          "Tarih"
        ],
        filterChips: [],
        tableOptions: {},
        isPopupActive: false,
        dates:[],
        localResult:[],
        uniqueBranches:[],
        tableActive: false,
        branchNameFilter: ''
    }
},
components: {
      GlobalFilter
    },
methods: {
  getUniqueBranches() {
  this.uniqueBranches = this.localResult.reduce((uniqueBranches, transaction) => {
    const branch = { branchName: transaction.branchName, branchCode: transaction.branchCode };
    const existingBranch = uniqueBranches.find(b => b.branchName === branch.branchName && b.branchCode === branch.branchCode);

    if (!existingBranch) {
      uniqueBranches.push(branch);
    }

    return uniqueBranches;
  }, []);
},
  getTotalAmount(branchName) {
    const transactions = this.localResult.filter(t => t.branchName === branchName);
    return transactions.reduce((total, t) => total + t.amount, 0);
  },
  getAmountForDate(branchName, date) {
    const transaction = this.localResult.find(t => t.branchName === branchName && t.dateString === date);
    return transaction ? transaction.amount : 0;
  },
   getDatesInRange(startDate, endDate) {
  const dates = [];
  let currentDate;
  let lastDate;

  if (!startDate) {
    const today = new Date();
    startDate = new Date(today.getFullYear(), today.getMonth(), 1); // Bulunduğumuz ayın ilk günü
  } else {
    startDate = new Date(startDate);
  }

  if (!endDate) {
    endDate = new Date(); // Bugünün tarihi
  } else {
    endDate = new Date(endDate);
  }

  currentDate = startDate;
  lastDate = endDate;

  while (currentDate <= lastDate) {
    const formattedDate = this.formatDate(currentDate);
    dates.push(formattedDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}
,
 formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
},
      saveOptions(filterOptions, filterChips) {
        console.log(filterChips);
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      clearFilter() {
        this.tableOptions = {
          sortBy: "Created",
          sortDirection: "desc",
          pageIndex: 0,
          pageSize: this.itemsPerPage,
          dateRange: {
            startDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
            endDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
          },
          timeRange: {
            startTime: null,
            endTime: null,
          },
          paymentMethod: null,
          extra: null,
          product: null,
          personal: null,
          order: null,
          price: {
            min: null,
            max: null,
          },
          dayReportType:null
        };
        this.filterChips.length = 0;
      },
      removeFilter(col, index) {
        //if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
         this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
      getExcelReport(){
        getExcel(this.tableOptions).then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Cüzdan Muhasebe Raporu" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
            this.isPopupActive = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      },
      getLocalReport(){
        let startLocalDate = this.tableOptions.dateRange && this.tableOptions.dateRange.startDate ? this.tableOptions.dateRange.startDate.toDateString() : null
        let endLocalDate= this.tableOptions.dateRange && this.tableOptions.dateRange.endDate ? this.tableOptions.dateRange.endDate.toDateString() : null
        this.dates = this.getDatesInRange(startLocalDate, endLocalDate);
        getAll(this.tableOptions).then((res) => {
          if (res && res.status == 200) {
           this.localResult = res.data;
           this.getUniqueBranches();
           console.log(this.localResult);
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Rapor Başarılı !",
            });
            this.isPopupActive = false;
            this.tableActive = true;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }
    },
    watch: {
      tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            console.log(this.tableOptions);
            this.isPopupActive = true;
            
            //this.getExcelReport();
          });
        },
      }
    }
}
</script>

<style>
#myTable {
    border-collapse: collapse;
    width: 100%;
  }
  #myTable th, #myTable td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
  }
  #myTable th {
    background-color: #f2f2f2;
    position: sticky;
  top: 50px;
  background: white;
  }
  #myTable {
  width: 100%;
  border-collapse: collapse;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

#myTable th,
#myTable td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

#myTable thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

#myTable thead th {
  background-color: #f2f2f2;
}

#myTable tbody {
  display: table;
  width: 100%;
  table-layout: fixed;
}

#myTable tbody tr {
  display: table-row;
}


.branch-name {
  width: 300px; /* İstediğiniz genişliği ayarlayın */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
  </style>